import { ButtonDS, DialogModalDS, Spacer, TextCapitalized } from "@qivia/ui";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { resetMemobankMandateBankVerificationProcessAsync } from "../sepaDirectDebitSlice";
import { selectAdminUser } from "../../homeSlice";

export const ResetBankVerificationProcessModal = (props: {
  visible: boolean;
  onCloseModal: () => void;
  currentMandateCompanyUuid: string;
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { visible, onCloseModal, currentMandateCompanyUuid } = props;
  const adminUser = useAppSelector(selectAdminUser);

  const resetModal = useCallback(() => {
    onCloseModal();
  }, [onCloseModal]);

  const clickToSubmit = useCallback(() => {
    if (!adminUser) return;

    void dispatch(
      resetMemobankMandateBankVerificationProcessAsync({
        mandateUuid: currentMandateCompanyUuid,
        updatedBy: adminUser.email,
      }),
    );

    onCloseModal();
  }, [currentMandateCompanyUuid, dispatch, onCloseModal, adminUser]);

  return (
    <DialogModalDS
      visible={visible}
      onClose={resetModal}
      title={t("memobankMandates.modal.resetVerificationProcess.title")}
      width={40}
      bottomButtons={{
        leftButton: (
          <ButtonDS
            text={t(`memobankMandates.modal.cancel`)}
            format={"fill"}
            buttonType={"secondary"}
            onClick={resetModal}
          />
        ),
        rightButton: (
          <ButtonDS
            text={t(`memobankMandates.modal.resetVerificationProcess.confirm`)}
            format={"fill"}
            buttonType={"primary"}
            onClick={clickToSubmit}
          />
        ),
      }}
    >
      <StyledColumn>
        <TextCapitalized>
          {t(`memobankMandates.modal.resetVerificationProcess.subtitle`)}
        </TextCapitalized>
        <Spacer y={1} />
        <TextCapitalized>
          {t(`memobankMandates.modal.resetVerificationProcess.message`)}
        </TextCapitalized>
        <Spacer y={3} />

        <Spacer y={1} />
        {t(`memobankMandates.modal.resetVerificationProcess.warning`)}
        <Spacer y={1} />
      </StyledColumn>
    </DialogModalDS>
  );
};

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;
